
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/trip-types/[tripType]",
      function () {
        return require("private-next-pages/trip-types/[tripType].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/trip-types/[tripType]"])
      });
    }
  